export const CONTRACT_COMPLETE_STAGES = ["signed", "canceled", "archived"];
export const OFR_COMPLETE_STAGES = ["signed", "canceled", "archived"];
export const RATING_STAGES = ["signed", "canceled"];

export const isContractStageIncomplete = (stage) =>
  !CONTRACT_COMPLETE_STAGES.includes(stage);

export const isOfrStageIncomplete = (stage) =>
  !OFR_COMPLETE_STAGES.includes(stage);

export const isContractsComplete = (trip) =>
  !(trip?.contractData || []).some((c) => isContractStageIncomplete(c.stage));

export const isOfrsComplete = (trip) =>
  !(trip?.operatorFinancialRecords || []).some((o) =>
    isOfrStageIncomplete(o.stage),
  );

export const isRatingsComplete = (trip) => {
  const ofrs = trip?.operatorFinancialRecords || [];
  const signedByOperator = new Map();

  ofrs
    .filter((ofr) => RATING_STAGES.includes(ofr.stage))
    .forEach((ofr) => {
      const id = ofr.operator?.id;
      if (!id) return;
      if (!signedByOperator.has(id)) signedByOperator.set(id, 0);
      if (ofr.stage === "signed") {
        signedByOperator.set(id, signedByOperator.get(id) + 1);
      }
    });

  const ratedOperatorIds = new Set(
    (trip?.operatorRatings || []).map((r) => r.operatorId),
  );

  for (const [operatorId, signedCount] of signedByOperator.entries()) {
    if (signedCount > 0 && !ratedOperatorIds.has(operatorId)) {
      return false;
    }
  }
  return true;
};

export const getVerifyBlockers = (trip, { incidentalsIncomplete } = {}) => {
  const blockers = [];
  if (!isContractsComplete(trip)) blockers.push("Contracts");
  if (!isOfrsComplete(trip)) blockers.push("OFRs");
  if (!isRatingsComplete(trip)) blockers.push("Operator Ratings");
  if (incidentalsIncomplete) blockers.push("Incidentals");
  return blockers;
};

export const isTripVerifiable = (trip, options) => getVerifyBlockers(trip, options).length === 0;
